import { render } from "./BostonNaming.vue?vue&type=template&id=5fb6e146&scoped=true"
import script from "./BostonNaming.vue?vue&type=script&lang=js"
export * from "./BostonNaming.vue?vue&type=script&lang=js"

import "./BostonNaming.vue?vue&type=style&index=0&id=5fb6e146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb6e146"]])

export default __exports__